import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 60vh;
  text-align: center;
  padding: 20px;
`;

const Title = styled.h1`
  font-size: 80px;
  color: #13519a;
  margin: 0;
  font-family: 'Impact', sans-serif;
`;

const Message = styled.p`
  font-size: 24px;
  color: #b0b0b0;
  margin-bottom: 30px;
`;

const HomeButton = styled(Link)`
  background-color: #ef6500;
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 18px;
  text-decoration: none;
  transition: background-color 0.3s;

  &:hover {
    background-color: #d15800;
  }
`;

const NotFound = () => {
  return (
    <Container>
      <SEO
        title="Page non trouvée | ImpactIsol"
        description="Page introuvable."
        noindex={true}
      />
      <Title>404</Title>
      <Message>Oups ! Cette page n'existe pas.</Message>
      <HomeButton to="/">Retour à l'accueil</HomeButton>
    </Container>
  );
};

export default NotFound;
